import React from "react";
import CatgryData from "./CatgryData";
import ReactSelect from "../../common/ReactSelect/ReactSelect";

const FieldNameDropdown = ({ defaultValue, onChange,isDisabled }) => {
  return (
    <>
      <ReactSelect
        options={CatgryData.filter(c=>c.value!=="all").map((t) => ({ value: t.value, label: t.label }))}
        onChange={(cat)=>{
          onChange((prev)=>{
            const updated = {...prev}
            if(cat){
              updated.field_name = cat.value
            }else{
              updated.field_name = ""
            }
            return updated;
          })
        }}
        defaultValue={defaultValue}
        isDisabled={isDisabled}
      />
    </>
  );
};

export default FieldNameDropdown;
